import PropTypes from 'prop-types';
import { useRef } from 'react';
import { Fade, makeStyles } from '@material-ui/core';
import { TransitionGroup } from 'react-transition-group';
import classNames from 'classnames';
import DraggableScroll from '../draggableScroll';
import { useDraggableScrollPosition } from '../../../utility/hooks';
import { asyncDebounce } from '../../../utility/helpers';
import ScrollIndicators from '../scrollIndicators';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    maxWidth: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  items: {
    display: 'flex',
    height: 52,
    maxWidth: '100%',
  },
  group: {
    display: 'flex',
  },
  scrollWrapper: {
    display: 'flex',
    height: spacing(13),
  },
}));

const SimpleHorizontalScroller = ({
  items,
  className = undefined,
  scrollArrowClass = undefined,
}) => {
  const classes = useStyles();
  const scrollRef = useRef(null);
  const itemsRef = useRef(null);
  const [
    activeScroll,
    onChangeScrollPosition,
    onScrollToRight,
    ,
    onScrollToStart,
  ] = useDraggableScrollPosition(scrollRef, itemsRef);

  return (
    <div className={classNames(classes.root, className)}>
      <DraggableScroll
        ref={el => {
          scrollRef.current = el;
        }}
        className={classNames(classes.scrollWrapper)}
        onEndScroll={asyncDebounce(onChangeScrollPosition)}
      >
        <div ref={itemsRef} className={classes.items}>
          <TransitionGroup className={classes.group}>
            {items.map((item, index) => {
              return (
                <Fade key={`nav_item_${index}`} in unmountOnExit>
                  {item}
                </Fade>
              );
            })}
          </TransitionGroup>
        </div>
      </DraggableScroll>
      <ScrollIndicators
        arrowLeftClass={scrollArrowClass}
        arrowRightClass={scrollArrowClass}
        activeScroll={activeScroll}
        onScrollToRight={onScrollToRight}
        onScrollToStart={onScrollToStart}
      />
    </div>
  );
};

SimpleHorizontalScroller.propTypes = {
  className: PropTypes.string,
  scrollArrowClass: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SimpleHorizontalScroller;
